import { Badge } from '@chakra-ui/react'
import { LEAD_STATUS_LABELS } from '../constants/leadEnums'

/**
 * Status Badge Component
 * Displays lead status with Jira-style color-coded badge
 */

// Jira-inspired status colors
const STATUS_STYLES = {
  NEW: {
    bg: '#DFE1E6',
    color: '#42526E',
  },
  ASSIGNED: {
    bg: '#E6FCFF',
    color: '#00A3BF',
  },
  IN_PROCESS: {
    bg: '#DEEBFF',
    color: '#0747A6',
  },
  CONVERTED: {
    bg: '#E3FCEF',
    color: '#006644',
  },
  CLOSED: {
    bg: '#F4F5F7',
    color: '#5E6C84',
  },
  DELETED: {
    bg: '#FFEBE6',
    color: '#BF2600',
  },
}

export function StatusBadge({ status }) {
  const label = LEAD_STATUS_LABELS[status] || status
  const styles = STATUS_STYLES[status] || STATUS_STYLES.CLOSED

  return (
    <Badge
      bg={styles.bg}
      color={styles.color}
      fontSize="xs"
      px={2}
      py={1}
      borderRadius="sm"
      fontWeight="600"
      textTransform="uppercase"
    >
      {label}
    </Badge>
  )
}

export default StatusBadge
